export default "__VITE_ASSET__c6adb02b__"